import React, { useEffect, useState } from 'react'
import { getInfrastructureProjects } from '../../../requests/public-infrastructure'
import { useParams } from 'react-router-dom'
import { IInfrastructureProject, InfrastructureProjectType } from '../../../types/project.types'
import classes from '../infrastructure-tabs/styles.module.scss';
import { MinusIcon, PlusBigIcon } from '../../../assets/icons';
import { useTranslation } from 'react-i18next';
import AdditionalFields from '../components/additional-fields.component';
import { convertFilesToImageDate } from '../../../helpers/utils';
import ImageGrid from '../components/image-grid.component';
import Documentation from '../components/documentation.component';
import classesLocal from './styles.module.scss';

const ImprovementProjectsTab = () => {
  const { i18n: { language } } = useTranslation();
  const { kato } = useParams<{ kato: string }>()
  const [list, setList] = useState<IInfrastructureProject[]>([])
  const [filteredList, setFilteredList] = useState<IInfrastructureProject[]>([])
  const [isOpen, setIsOpen] = useState<Record<number, boolean>>({})
  const [filters, setFilters] = useState<{ name: string, from: string, to: string }>({ name: '', from: '', to: '' })

  const suffix = language === 'ru' ? 'Ru' : 'Kz';


  useEffect(() => {
    if (!kato) return;
    getInfrastructureProjects(kato, InfrastructureProjectType.SNP_IMPROVEMENT)
      .then((res: any) => {
        setList(res);
        setFilteredList(res);
      })
      .catch((error: any) => {
        console.error('Error fetching investment projects:', error);
      });
  }, [kato])


  useEffect(() => {
    const filtered = list.filter(item => {
      const matchesName = item[`name${suffix}`]
        ?.toLowerCase()
        .includes(filters.name.toLowerCase() ?? '');

      // преобразуем строки в Date
      const itemStart = item.workStart ? new Date(item.workStart) : null;
      const itemEnd = item.workEnd ? new Date(item.workEnd) : null;
      const fromDate = filters.from ? new Date(filters.from) : null;
      const toDate = filters.to ? new Date(filters.to) : null;

      let matchesDate = true;

      // проверка "сверху" — проект должен пересекать выбранный период
      if (fromDate && itemEnd && itemEnd < fromDate) {
        matchesDate = false;
      }
      if (toDate && itemStart && itemStart > toDate) {
        matchesDate = false;
      }

      if(!filters.from && !filters.to && filters.name.trim() === '') return true;

      return matchesName && matchesDate;
    });

    setFilteredList(filtered);
  }, [filters, list, suffix]);

  return (
    <div>
      <div className={classesLocal['filters']}>
        <div className={classesLocal['filters__dates']}>
          <span>Период:</span>
          <input type="date" name="from" id="from" value={filters.from} onChange={(e) => setFilters(prev => ({ ...prev, from: e.target.value }))} />
          <span>-</span>
          <input type="date" name="to" id="to" value={filters.to} onChange={(e) => setFilters(prev => ({ ...prev, to: e.target.value }))} />
        </div>

        <input
          type="text"
          placeholder="Поиск..."
          value={filters.name}
          onChange={(e) => setFilters(prev => ({ ...prev, name: e.target.value }))}
        />
      </div>
      <div className={classes['items-list']}>
        {filteredList.map(item => (
          <div key={item.id} className={classes['project-item']}>
            <div
              className={classes['project-item__header']}
              onClick={() =>
                setIsOpen(prev => ({ ...prev, [item.id]: !prev[item.id] }))
              }
            >
              <div className={classes['project-item__icon']}>
                {isOpen[item.id] ? <MinusIcon /> : <PlusBigIcon />}
              </div>
              <span className={classes['project-item__title']}>
                {item[`name${suffix}`] ?? '-'}
              </span>
            </div>

            {isOpen[item.id] && (
              <div className={classes['project-item__body']}>
                <Documentation data={item} />
                {item.additionalFields && <AdditionalFields data={item.additionalFields} />}
                {item.files && <ImageGrid images={convertFilesToImageDate(item.files)} />}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>

  )
}

export default ImprovementProjectsTab